import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const OnboardingContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100dvh;

  overflow-y: auto;

  background-color: ${({ theme }) => theme.palette.grey[100]};
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(12)};

  width: 100%;
  max-width: 104rem;
  margin: 0 auto;
  padding: ${({ theme }) =>
    `${theme.spacing(10)} ${theme.spacing(4)} ${theme.spacing(12)}`};
`;

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};

  text-align: center;
`;

export const HeroIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 4rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const HeroTitle = styled.h1`
  ${({ theme }) => typographyToCss(theme.typography.h2)};

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Subtitle = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body1)};

  max-width: 46rem;
  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ContinueFree = styled.div`
  display: flex;
  justify-content: center;

  color: ${({ theme }) => theme.palette.text.secondary};
`;
